import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dt-instructions" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Select a method to share your screen", -1)
const _hoisted_3 = { class: "dt-instructions__instructions-container" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__instruction" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "dt-instructions__instruction-image",
    src: "/icons/download@2x.png"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__text-content" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "dt-instructions__instruction-title" }, "Option 1"),
    /*#__PURE__*/_createElementVNode("h3", { class: "dt-instructions__instruction-subtitle" }, "Install"),
    /*#__PURE__*/_createElementVNode("p", { class: "dt-instructions__instruction-description" }, "Install the Ditto Connect app to begin sharing.")
  ])
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__instruction" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "dt-instructions__instruction-image",
    src: "/icons/ditto@2x.png"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__text-content" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "dt-instructions__instruction-title" }, "Option 2"),
    /*#__PURE__*/_createElementVNode("h3", { class: "dt-instructions__instruction-subtitle" }, "Download"),
    /*#__PURE__*/_createElementVNode("p", { class: "dt-instructions__instruction-description" }, "Download and run a temporary version of the Ditto Connect app.")
  ])
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__instruction" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "dt-instructions__instruction-image",
    src: "/icons/continue@2x.png"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__text-content" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "dt-instructions__instruction-title" }, "Option 3"),
    /*#__PURE__*/_createElementVNode("h3", { class: "dt-instructions__instruction-subtitle" }, "Continue"),
    /*#__PURE__*/_createElementVNode("p", { class: "dt-instructions__instruction-description" }, "Share your screen with this browser.")
  ])
], -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_TransitionGroup, {
        appear: "",
        name: "fade-up"
      }, {
        default: _withCtx(() => [
          _createElementVNode("a", {
            key: "1",
            href: _ctx.getInstallLink,
            target: "_blank",
            rel: "noreferrer noopener",
            class: "dt-instructions__instruction-container"
          }, _hoisted_6, 8, _hoisted_4),
          _createElementVNode("button", {
            key: "2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.continueToDownloadClickHandler && _ctx.continueToDownloadClickHandler(...args))),
            class: "dt-instructions__instruction-container"
          }, _hoisted_8),
          (_ctx.isSupportedBrowser && _ctx.loadWasm && _ctx.isSSPReceiver)
            ? (_openBlock(), _createElementBlock("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.continueOnBrowserClickHandler && _ctx.continueOnBrowserClickHandler(...args))),
                key: "3",
                type: "button",
                class: _normalizeClass(["dt-instructions__instruction-container", { 'dt-instructions__instruction-container--disabled' : !_ctx.isSupportedBrowser }])
              }, _hoisted_10, 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}